export default "__VITE_ASSET__DHVh_mI8__"